import axios from 'axios';
import { ResponseList } from 'models/Common';
import { GoogleRequest } from 'data/schemas/google';

export async function getGoogleMetrics(params?: GoogleRequest) {
    return axios.get<ResponseList<GoogleRequest[]>>('v1/google-metrics', {
        params: params
    });
}
